import { Children, ReactNode } from 'react';

export const shouldPseudolocalize =
  typeof window !== 'undefined' &&
  window.document.documentElement.lang === 'bidi';

const pseudolocalizeChild = (child: Exclude<ReactNode, Array<ReactNode>>) => {
  if (typeof child === 'string') {
    return `\u202e${child}\u202c`;
  }

  return child;
};

export const pseudolocalize = (children?: ReactNode) => {
  if (Children.count(children) === 1) {
    return pseudolocalizeChild(children);
  }

  if (Children.count(children) > 1) {
    return Children.map(children, pseudolocalizeChild);
  }

  return children;
};
